const csvCell = (value) => {
  if (value === null || value === undefined) return '""';
  const text = typeof value === 'number' ? (Number.isFinite(value) ? String(value) : '') : String(value);
  const safe = typeof value === 'string' && /^[\s]*[=+\-@]/.test(text) ? `'${text}` : text;
  return `"${safe.replace(/"/g, '""')}"`;
};

const lastValue = (series) => {
  if (!Array.isArray(series)) return [];
  for (let index = series.length - 1; index >= 0; index -= 1) {
    const point = series[index];
    if (Array.isArray(point) && Number.isFinite(point[0]) && Number.isFinite(point[1])) {
      const date = new Date(point[0]);
      if (Number.isFinite(date.getTime())) return [date.toISOString().slice(0, 10), point[1]];
    }
  }
  return [];
};

export const dashboardCsv = (tickers, entries) => {
  const rows = [[
    'Ticker', 'Company', 'Status', 'Close Date', 'Close Price',
    'Daily Forecast Date', 'Daily Forecast Price',
    'Two-Day Forecast Date', 'Two-Day Forecast Price',
    'Weekly Forecast Date', 'Weekly Forecast Price',
    'Materialized Date', 'Daily Accuracy (0-1)',
  ]];
  tickers.forEach((ticker) => {
    const entry = entries[ticker];
    const data = entry?.status === 'available' ? entry.data : undefined;
    const [closeDate, closePrice] = lastValue(data?.close);
    const predictions = data?.info?.predictions;
    rows.push([
      ticker, data?.info?.name, entry?.status || 'loading', closeDate, closePrice,
      predictions?.daily_prediction_date, predictions?.daily_prediction,
      predictions?.two_day_prediction_date, predictions?.two_day_prediction,
      predictions?.weekly_prediction_date, predictions?.weekly_prediction,
      data?.info?.materializedDate,
      data?.info?.metrics?.daily_accuracy,
    ]);
  });
  return '\uFEFF' + rows.map((row) => row.map(csvCell).join(',')).join('\r\n') + '\r\n';
};

export const downloadDashboardCsv = (tickers, entries) => {
  const url = URL.createObjectURL(new Blob([dashboardCsv(tickers, entries)], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = 'deeptrading-dashboard.csv';
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
